/* eslint-disable  no-restricted-syntax */
import { createSelector } from 'reselect'

import { RootState } from '~/core/store/root.reducer'

export const getRouter = (state: RootState) => state.router

export const selectQueryParams = createSelector(getRouter, (router) => {
  return Object.keys(router.queryParams).map((queryParam) => queryParam)
})
